import { render, staticRenderFns } from "./dycommon.vue?vue&type=template&id=f3952bbe&scoped=true"
import script from "./dycommon.vue?vue&type=script&lang=js"
export * from "./dycommon.vue?vue&type=script&lang=js"
import style0 from "./dycommon.vue?vue&type=style&index=0&id=f3952bbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3952bbe",
  null
  
)

export default component.exports